import BaseApi from './base/BaseApi';

export default class CrmRejectionReasonApi extends BaseApi {
  static entityName = 'crm_rejection_reasons';
}
